import React, { useEffect, useRef, useState } from "react";
import listaVerificacionServicio from "../../services/ListaVerificacion/listaVerificacionServicio";
import {
  IItemListaVerificacionTablePorSupervisor,
  IRequetTableHistoricoPorSupervisor,
} from "../../Interfaces/IListaVerificacion";
import { InitialTableHistoricoPorSupervisor } from "../../utils/Initials/ListaVerificacion";
import { ISearchBox } from "@fluentui/react";
import { _formatDate } from "../../utils/helpers/dateHelpers";
import { IPaginacion } from "../../Interfaces/filter";
interface IFilterFechasDate {
  filterFechaInicio: Date | undefined;
  filterFechaFin: Date | undefined;
}
export const useSupervisorHistorial = () => {
  const controllerRef = useRef<AbortController>(new AbortController());
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);

  const [isLoading, setIsLoading] = useState(false);
  const searchBoxRefTable = useRef<ISearchBox>(null);

  const [filterFechas, setFilterFechas] = useState<IFilterFechasDate>({
    filterFechaInicio: new Date(),
    filterFechaFin: new Date(),
  });
  const [filter, setFilter] = useState<IRequetTableHistoricoPorSupervisor>(
    InitialTableHistoricoPorSupervisor
  );
  const [dataTable, setDataTable] = useState<
    IItemListaVerificacionTablePorSupervisor[]
  >([]);

  const _onkeyUpSearchTable = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };
  const onChangeComboBox = (e, o, text) => {
    if (e !== undefined) {
      switch (text) {
        case "modeloEquipo":
          setFilter({ ...filter, equipoModeloId: o.key });
          break;
        case "equipo":
          setFilter({ ...filter, equipoId: o.key });
          break;
        case "tipoEquipo":
          setFilter({ ...filter, tipoEquipoId: o.key });
          break;
        default:
          break;
      }
    }
  };
  const _onChangeChoiceGroup = (e, o) => {
    if (e !== undefined) {
      setFilter({ ...filter, estadoId: o.key });
    }
  };
  const _onSelectDate = (date, text) => {
    switch (text) {
      case "inicio":
        setFilterFechas({ ...filterFechas, filterFechaInicio: date });
        setFilter({ ...filter, fechaInicio: _formatDate(date, ",") });
        break;
      case "fin":
        setFilter({ ...filter, fechaFin: _formatDate(date, ",") });
        setFilterFechas({ ...filterFechas, filterFechaFin: date });
        break;
      default:
        break;
    }
  };

  const postTabletChechList = () => {
    controllerRef.current.abort();
    const newController = new AbortController();
    controllerRef.current = newController;
    setIsLoading(true);
    listaVerificacionServicio
      .postListarCheckListPorSupervisor(filter, newController)
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setDataTable(res.data.items);
          setPaginacion({
            pages: res.data.pages,
            total: res.data.total,
            page: res.data.page,
          });
        } else {
          setIsLoading(false);
        }
      });
  };
  const onChangeSkip = (evento: string) => {
    switch (evento) {
      case "next":
        setFilter({ ...filter, skip: filter.skip + 1 });
        break;
      case "prev":
        setFilter({ ...filter, skip: filter.skip - 1 });
        break;

      default:
        break;
    }
  };

  const limpiarFiltor = () => {
    setFilter(InitialTableHistoricoPorSupervisor);
    setFilterFechas({
      filterFechaFin: new Date(),
      filterFechaInicio: new Date(),
    });
  };

  const Actualizar = () => {
    postTabletChechList();
  };

  useEffect(() => {
    postTabletChechList();
  }, [filter]);
  return {
    dataTable,
    isLoading,
    filterFechas,
    _onkeyUpSearchTable,
    searchBoxRefTable,
    onChangeComboBox,
    _onChangeChoiceGroup,
    _onSelectDate,
    limpiarFiltor,
    Actualizar,
    filter,
    onChangeSkip,
    paginacion
  };
};
